import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useIsCurrentUserDeviationAuthor } from '../../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { useDeviationAttributes } from '../../../../hooks/useDeviationAttributes';
import FaveButton from '../../../../../FaveButton';
import FavingIcon from '../../../../../FaveButton/FavingIcon';
import s from './FaveControl.scss';
const FaveControl = ({ deviation , className , iconClassName , textClassName  })=>{
    const { t  } = useTranslation();
    const isMobile = useContext(MobileContext);
    const isOwner = useIsCurrentUserDeviationAuthor(deviation);
    const { isFavouritable  } = useDeviationAttributes(deviation, isOwner);
    const renderFaveButtonContent = ({ isFavourite , faveCount  })=>{
        if (isMobile) {
            return /*#__PURE__*/ React.createElement(ThumbIconButton, {
                type: "fave",
                statValue: faveCount,
                isEngaged: isFavourite
            });
        } else {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FavingIcon, {
                className: iconClassName,
                deviationId: deviation.deviationId,
                isFavourited: isFavourite,
                size: IconSize.MEDIUM,
                withPadding: false,
                disableDefaultColors: true,
                "aria-label": t('deviationview.overlay.a11y.favourite')
            }), /*#__PURE__*/ React.createElement("span", {
                className: textClassName
            }, t(isFavourite ? 'actionbar.inFavourites' : 'actionbar.addToFavourites')));
        }
    };
    return isFavouritable ? /*#__PURE__*/ React.createElement(FaveButton, {
        className: classnames(s['root'], className),
        deviation: deviation,
        "aria-label": t('deviationview.overlay.a11y.favourite')
    }, renderFaveButtonContent) : null;
};
FaveControl.displayName = 'FaveControl';
export default FaveControl;
